import { render, staticRenderFns } from "./DateFormItem.vue?vue&type=template&id=68e976a8&scoped=true&"
import script from "./DateFormItem.vue?vue&type=script&lang=js&"
export * from "./DateFormItem.vue?vue&type=script&lang=js&"
import style0 from "./DateFormItem.vue?vue&type=style&index=0&id=68e976a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e976a8",
  null
  
)

export default component.exports